import { useEffect, useRef, useState } from 'react';

import CollapsingHeader from './CollapsingHeader/CollapsingHeader';
import SingleDropDown from '../../SingleDropDown';
// import Required from './Required';

import styles from './SizeAndWeightStyles.module.css';
import { useStyles } from '../../../Styles/styles';
import { formatNameFromVehicleObj } from '../../../utils/utils';
import MultiDropDownObjects from '../../MultiDropDownObjects';
import Required from './Required/Required';

const PowerUnitAndTrailers = ({
  handleChange = () => alert('handleChange not defined in PowerUnitAndTrailers'),
  vehicles = [],
  powerUnit = {},
  trailers = [],
  userRoles = [],
  missingFields = [],
  disabled = false,
  nightMode = false,
  locked = false,
  ...props
}) => {
  const classes = useStyles();

  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  const powerUnitOptions = !locked ? vehicles?.filter(vehicle => !trailers?.some(trailer => trailer?.id === vehicle?.id)) : vehicles;
  const trailerOptions = !locked ? vehicles?.filter(vehicle => vehicle?.id !== powerUnit?.id) : vehicles;

  return (
    <CollapsingHeader nightMode={nightMode} title={"Vehicles"} defaultOpen={true}>
      <div className={styles['flexRow']}>
        <Required
          required={missingFields.some(field => field?.name === "powerUnit")}
          message={missingFields.find(field => field?.name === "powerUnit")?.error}
        >
          <SingleDropDown
            disabled={disabled}
            handleChange={(e) => {
              handleChange(e.target.value, 'UPDATE_PROPERTY', { property: 'powerUnit' })
            }}
            stateName={'vehicle'}
            value={powerUnit}
            options={powerUnitOptions}
            title={"Power Unit"}
            selectStyle={classes.singleDropDownPaddingAdjustment}
            inputLabel={inputLabel}
            labelWidth={labelWidth}
            nameFormatter={formatNameFromVehicleObj}
            userRoles={userRoles}
            {...props}
          />
        </Required>
        <MultiDropDownObjects
          id={"trailers"}
          data-cy={"trailers"}
          title={"Trailers"}
          stateName={"trailers"}
          handleChange={(e) => handleChange(e.target.value, 'UPDATE_PROPERTY', { property: 'trailers' })}
          selectedValues={trailers ? vehicles?.filter(option => trailers?.some(swe => option?.id === swe?.id)) : []}
          options={trailerOptions}
          formStyle={classes.formControl}
          labelStyle={classes.multiInputLabel}
          selectStyle={null}
          chipsStyle={styles['flexColumn']}
          chipStyle={classes.chip}
          userRoles={userRoles}
          nameFormatter={formatNameFromVehicleObj}
          disabled={disabled}
          {...props}
        />
      </div>
    </CollapsingHeader>
  );
}

export default PowerUnitAndTrailers;